<template>
    <div class="faqGroup" v-bind:id="link">
        <div class="faqGroupTitle">
            <h4 class="title">{{ title }}</h4>
            <div v-if="description" class="description">{{ description }}</div>
        </div>
        <div class="faqElements" style="margin-bottom: 10px">
            <FAQElement
                    v-for="faq in faqs"
                    :key="faq.question"
                    v-bind="faq"
            />
        </div>
    </div>
</template>

<script>
    import FAQElement from "./FAQElement";
    export default {
        components: {FAQElement},
        props: ['title',  'description', 'faqs', 'link'],
    }
</script>
